import { liveStreamingMode } from "../../../modes";
import { queryType } from "../../../common";
export var config = {
    alternative: false,
    colorful: false,
    mode: "Sport",
    enableAllSports: false,
    enableFavorites: false,
    isFavoritesFirst: true,
    liveStreamingMode: liveStreamingMode.firstSelected,
    enableLiveStreaming: false,
    sportOrder: [],
    blockId: "filter_block",
    query: queryType.preLive,
    hideSportIconOnMobile: true,
    sportRetrieverUpdatePeriod: 180000,
    liveStreamingUpdatePeriod: 30000,
};
//# sourceMappingURL=config.js.map